import { render, staticRenderFns } from "./BoardItem.vue?vue&type=template&id=ed662286&"
import script from "./BoardItem.vue?vue&type=script&lang=js&"
export * from "./BoardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports